import axios from 'axios';
import { API_URL } from '../../constants';

class CustomerOnboardingService {
    async getCustomerAccountSetupFormData(token) {
        const url = `${API_URL}/get-customer-account-setup-form-data/${token}/`;
        return axios({
            url: url,
            method: 'GET'
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async saveCustomerAccountSetupForm(data) {
        const url = `${API_URL}/save-customer-account-setup-form/`;
        const headers = (data instanceof FormData) ? {
            'Content-Type': 'multipart/form-data'
        } : {
            'Content-Type': 'application/json'
        };

        return axios({
            url: url,
            method: 'POST',
            data: data,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }
}

export default CustomerOnboardingService;
